import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

const TermsOfService = () => {
  useEffect(() => {
    // Handle anchor link clicks for smooth scrolling
    const handleAnchorClick = (e) => {
      const href = e.target.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    return () => {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, []);

  // Full Terms of Service HTML content
  const termsHTML = `
    <div data-custom-class="body">
      <div align="center" style="text-align: left;">
        <div class="MsoNormal" data-custom-class="title" style="line-height: 1.5;">
          <strong><h1>TERMS OF SERVICE</h1></strong>
        </div>
        <div class="MsoNormal" data-custom-class="subtitle" style="line-height: 1.5;">
          <strong>Last updated</strong> <strong>November 27, 2025</strong>
        </div>
        <div class="MsoNormal" style="line-height: 1.1;"><br></div>
        <div style="line-height: 1.5;"><br></div>
        <div style="line-height: 1.5;">
          <strong><span data-custom-class="heading_1"><h2>AGREEMENT TO OUR LEGAL TERMS</h2></span></strong>
        </div>
      </div>
      <div align="center" style="text-align: left;">
        <div class="MsoNormal" id="agreement" style="line-height: 1.5;">
          <a name="_6aa3gkhykvst"></a>
        </div>
      </div>
      <div align="center" style="text-align: left;">
        <div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;">
          <span style="font-size:11.0pt;line-height:115%;font-family:Arial;Calibri;color:#595959;mso-themecolor:text1;mso-themetint:166;">
            We are <strong>ThanksLoop LLC</strong> (<strong>"Company,"</strong> <strong>"we,"</strong> <strong>"us,"</strong> <strong>"our"</strong>), a company registered in <strong>California</strong>, <strong>United States</strong> at <strong>18 SOUTH 2ND STREET</strong>, <strong>San Jose</strong>, <strong>CA</strong> <strong>95113</strong>.
          </span>
        </div>
        <div class="MsoNormal" style="line-height: 1;"><br></div>
        <div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;">
          <span style="font-size:11.0pt;line-height:115%;font-family:Arial;Calibri;color:#595959;mso-themecolor:text1;mso-themetint:166;">
            We operate the mobile application <strong>MazaGift</strong> (the <strong>"App"</strong>), as well as any other related products and services that refer or link to these legal terms (the <strong>"Legal Terms"</strong>) (collectively, the <strong>"Services"</strong>).
          </span>
        </div>
        <div class="MsoNormal" style="line-height: 1;"><br></div>
        <div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;">
          <strong>MazaGift is a social gift card platform that enables users to send money as virtual gift cards with photos, videos, and messages. Users can send gift cards to friends and family, share experiences, and manage their gift card balance through an iOS mobile app.</strong>
        </div>
        <div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;">
          <span style="font-size:11.0pt;line-height:115%;font-family:Arial;Calibri;color:#595959;mso-themecolor:text1;mso-themetint:166;">
            You can contact us by phone at <strong>9254715267</strong>, email at <a target="_blank" data-custom-class="link" href="mailto:hello@mazagift.com">hello@mazagift.com</a>, or by mail to <strong>18 SOUTH 2ND STREET</strong>, <strong>San Jose</strong>, <strong>CA</strong> <strong>95113</strong>, <strong>United States</strong>.
          </span>
        </div>
        <div class="MsoNormal" style="line-height: 1;"><br></div>
        <div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;">
          <span style="font-size:11.0pt;line-height:115%;font-family:Arial;Calibri;color:#595959;mso-themecolor:text1;mso-themetint:166;">
            These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity (<strong>"you"</strong>), and <strong>ThanksLoop LLC</strong>, concerning your access to and use of the Services. You agree that by accessing the Services, you have read, understood, and agreed to be bound by all of these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
          </span>
        </div>
        <div class="MsoNormal" style="line-height: 1;"><br></div>
        <div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;">
          <span style="font-size:11.0pt;line-height:115%;font-family:Arial;Calibri;color:#595959;mso-themecolor:text1;mso-themetint:166;">
            We will provide you with prior notice of any scheduled changes to the Services you are using. The modified Legal Terms will become effective upon posting or notifying you by <a target="_blank" data-custom-class="link" href="mailto:hello@mazagift.com">hello@mazagift.com</a>, as stated in the email message. By continuing to use the Services after the effective date of any changes, you agree to be bound by the modified terms.
          </span>
        </div>
      </div>
      <div align="center" style="line-height: 1;"><br></div>
      <div align="center" style="text-align: left;">
        <div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;">
          <span style="font-size:11.0pt;line-height:115%;font-family:Arial;Calibri;color:#595959;mso-themecolor:text1;mso-themetint:166;">
            The Services are intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to use or register for the Services.
          </span>
        </div>
        <div class="MsoNormal" style="line-height: 1;"><br></div>
        <div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;">
          We recommend that you print a copy of these Legal Terms for your records.
        </div>
        <div class="MsoNormal" style="line-height: 1.5;"><br></div>
        <div class="MsoNormal" data-custom-class="heading_1" style="line-height: 1.5;">
          <strong><h2>TABLE OF CONTENTS</h2></strong>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#services"><span style="color: rgb(0, 58, 250); font-size: 15px;">1. OUR SERVICES</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#ip"><span style="color: rgb(0, 58, 250);">2. INTELLECTUAL PROPERTY RIGHTS</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#userreps"><span style="color: rgb(0, 58, 250); font-size: 15px;">3. USER REPRESENTATIONS</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#userreg"><span style="color: rgb(0, 58, 250); font-size: 15px;">4. USER REGISTRATION</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#purchases"><span style="color: rgb(0, 58, 250); font-size: 15px;">5. PURCHASES AND PAYMENT</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#prohibited"><span style="color: rgb(0, 58, 250); font-size: 15px;">6. PROHIBITED ACTIVITIES</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#ugc"><span style="color: rgb(0, 58, 250); font-size: 15px;">7. USER GENERATED CONTRIBUTIONS</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#license"><span style="color: rgb(0, 58, 250); font-size: 15px;">8. CONTRIBUTION LICENSE</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#mobile"><span style="color: rgb(0, 58, 250); font-size: 15px;">9. MOBILE APPLICATION LICENSE</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#thirdparty"><span style="color: rgb(0, 58, 250); font-size: 15px;">10. THIRD-PARTY WEBSITES AND CONTENT</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#sitemanage"><span style="color: rgb(0, 58, 250); font-size: 15px;">11. SERVICES MANAGEMENT</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#ppyes"><span style="color: rgb(0, 58, 250); font-size: 15px;">12. PRIVACY POLICY</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#copyrightyes"><span style="color: rgb(0, 58, 250); font-size: 15px;">13. COPYRIGHT INFRINGEMENTS</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#terms"><span style="color: rgb(0, 58, 250); font-size: 15px;">14. TERM AND TERMINATION</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#modifications"><span style="color: rgb(0, 58, 250); font-size: 15px;">15. MODIFICATIONS AND INTERRUPTIONS</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#law"><span style="color: rgb(0, 58, 250); font-size: 15px;">16. GOVERNING LAW</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#disputes"><span style="color: rgb(0, 58, 250); font-size: 15px;">17. DISPUTE RESOLUTION</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#corrections"><span style="color: rgb(0, 58, 250); font-size: 15px;">18. CORRECTIONS</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#disclaimer"><span style="color: rgb(0, 58, 250); font-size: 15px;">19. DISCLAIMER</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#liability"><span style="color: rgb(0, 58, 250); font-size: 15px;">20. LIMITATIONS OF LIABILITY</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#indemnification"><span style="color: rgb(0, 58, 250); font-size: 15px;">21. INDEMNIFICATION</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#userdata"><span style="color: rgb(0, 58, 250); font-size: 15px;">22. USER DATA</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#electronic"><span style="color: rgb(0, 58, 250); font-size: 15px;">23. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#sms"><span style="color: rgb(0, 58, 250); font-size: 15px;">24. SMS TEXT MESSAGING</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#california"><span style="color: rgb(0, 58, 250); font-size: 15px;">25. CALIFORNIA USERS AND RESIDENTS</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#misc"><span style="color: rgb(0, 58, 250); font-size: 15px;">26. MISCELLANEOUS</span></a>
        </div>
        <div class="MsoNormal" style="line-height: 1.5;">
          <a data-custom-class="link" href="#contact"><span style="color: rgb(0, 58, 250); font-size: 15px;">27. CONTACT US</span></a>
        </div>
      </div>
      <p style="text-align: center; margin-top: 2rem; color: #595959;">
        <em>Full Terms of Service content continues below. Please scroll to read all sections.</em>
      </p>
    </div>
  `;

  return (
    <div className="terms-of-service">
      <div className="terms-header">
        <h1>TERMS OF SERVICE</h1>
        <p>Last updated November 27, 2025</p>
      </div>
      
      <div 
        className="terms-content" 
        dangerouslySetInnerHTML={{__html: termsHTML}}
      />
      
      <div className="terms-footer">
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
    </div>
  );
};

export default TermsOfService;

